import './MoleculesDetails.css';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Lottie from 'react-lottie';

import back from '../assets/Back.svg';
import closeDropDown from '../assets/closeDropDown.svg';
import dropDown from '../assets/dropDown.svg';
import speech from '../assets/Speech.svg';
import filledBlueSpeech from '../assets/filledBlueSpeech.svg';
import hollowSpeech from '../assets/hollowSpeech.svg';
import share from '../assets/Share.svg';
import hollowFavourite from '../assets/hollowFavourite.svg';
import restart from '../assets/restart.svg';
import blueMic from '../assets/blueMic.svg';
import roundedCancel from '../assets/roundedCancel.svg';
import goodJob from '../assets/goodJob.svg';
import celebration from '../assets/celebration.svg';
import favourite from '../assets/Favourite.svg';
import Animation from '../assets/Animation.json';
import flower from '../assets/flower.svg';

import AudioVisualizer from '../components/AudioVisualizer';
import SpeakText from './SpeakText';
import SpeechRecognition from './SpeechRecognition';
import PopupMSG from './PopupMSG';

const MoleculeDetails = () => {
    // const { id } = useParams(); // Get the 'id' from the URL
    const [showVisualizer, setShowVisualizer] = useState(false);
    const [showWordBreakVisualizer, setShowWordBreakVisualizer] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [isResetSpinning, setIsResetSpinning] = useState(false);
    // const [bookmark, setBookMark] = useState(false);

    const location = useLocation();
    const from = location.state?.from;
    const { moleculeDetails } = location.state || {};
    const [isFavorite, setIsFavorite] = useState(location.state?.isFavorite || false);


    const [isMicClicked, setIsMicClicked] = useState(false);
    const [accuracy, setAccuracy] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [highlightedSyllables, setHighlightedSyllables] = useState([]);
    const [spokenText, setSpokenText] = useState('');


    const handleHollowSpeechClick = () => {
        // Toggle the visualizer and play/pause state together
        // setShowVisualizer(prev => !prev); // Toggle the visibility of the visualizer
        if (showVisualizer) {
            setShowVisualizer(false);
        } else {
            setShowVisualizer(true);
        }
    };

    const handleVoiceBreakSpeech = () => {
        if (showWordBreakVisualizer) {
            setShowWordBreakVisualizer(false);
        } else {
            setShowWordBreakVisualizer(true);
        }
    }

    const onSpeechEnd = () => {
        setShowVisualizer(false);
        setShowWordBreakVisualizer(false);
    }

    const handleDetailsDropDown = () => {
        // setShowVisualizer(false);
        setShowDetails(!showDetails);
    }

    const startRecognition = () => {
        setIsMicClicked(true);
    };

    const resetMic = () => {
        setIsMicClicked(false);  // Reset mic state after finishing recognition
        setIsResetSpinning(true);
        setSpokenText('');
        setShowPopup(false);
        setTimeout(() => {
            setIsResetSpinning(false); // Stop the spinning animation after 1 second
        }, 2000);
    };

    const handleWordComplete = (isComplete, acc, highlight, wspokenText) => {
        if (highlight) setHighlightedSyllables(highlight);
        setSpokenText(wspokenText);
        if (isComplete) {
            setShowPopup(true);
            setAccuracy(acc);
            setTimeout(() => {
                setShowPopup(false);
                setIsMicClicked(false);
                setHighlightedSyllables([]);
            }, 8000);
            console.log(spokenText);
        }
        else if (isComplete === null) {
            setIsMicClicked(false);
        }
    };

    const addToBookmark = async () => {

        let data = {
            UserId: sessionStorage.getItem('userId'),
            Type: 'Molecule',
            Molecule_Name: moleculeDetails.Molecule_Name,
            Associated_Brands: moleculeDetails?.Associated_Brands,
            Vocab_Breakdown: moleculeDetails?.Vocab_Breakdown,
            Definition: moleculeDetails?.Definition,
            Mode_of_Action: moleculeDetails?.Mode_of_Action,
            Common_Usage: moleculeDetails?.Common_Usage,
            action: isFavorite ? 'delete' : 'add'
        }
        const apiUrl = 'https://alembicdigilabs.in/medicaldictionary/v1/eyecare/favourites';

        try {
            const response = await fetch(apiUrl, {
                method: 'POST', // HTTP method
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${sessionStorage.getItem('token')}`
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                const result = await response.json();
                // setBookMark(prev => !prev);
                setIsFavorite(prev => !prev);
                console.log('Response:', result); // Log the response from the API
            } else {
                console.error('Error:', response.statusText); // Log any errors
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const backLink =
        from === "/dictionary"
            ? "/dictionary"
            : from === "/molecule"
                ? "/molecule"
                : "/dictionary";

    // You can use the 'id' to fetch data for the item or just display it.
    // Example: Assuming you have a way to fetch details using the id.

    const defaultOptions = {
        loop: true,  // Whether the animation should loop or not
        autoplay: true,  // Whether the animation should start playing automatically
        animationData: Animation,  // The JSON data for the animation
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',  // Adjust how the animation scales
        },
    };


    return (
        <div className="dictionary-container">
            <header className="text-left py-3 d-flex gap-3">
                <Link to={backLink} className="text-decoration-none align-self-center">
                    <img src={back} alt="Back" className="dictionary-icon mb-3" />
                </Link>
                <p className='dictionaryHeader'>Molecule</p>
            </header>
            {/* Render the details of the item here */}

            <div className='detailsContainer'>
                <div className='d-grid align-items-center' style={{ gridTemplateColumns: '7fr 1fr' }}>
                    <p className='mb-0 fs-3'>{moleculeDetails.Molecule_Name}</p>
                    <img src={showDetails ? dropDown : closeDropDown} alt='hide' className='col-md-4' style={{ justifySelf: 'end' }} onClick={handleDetailsDropDown} />
                </div>
                {showVisualizer && (
                    <AudioVisualizer />
                )}

                {showVisualizer && <SpeakText textToSpeak={moleculeDetails.Molecule_Name} speechRate={'0.7'} onSpeechEnd={onSpeechEnd} />}

                <div className='vocab-breakdown mt-4 px-3' style={showWordBreakVisualizer ? { height: '160px' } : { height: '110px' }}>
                    <div className='d-flex justify-content-between align-items-center' style={{ borderBottom: '2px solid rgba(218, 223, 230, 1)' }}>
                        <span className='fs-12'>Vocab Breakdown:</span>
                        <img src={showWordBreakVisualizer ? filledBlueSpeech : speech} alt='speaker' style={{ height: '1.2rem' }} onClick={handleVoiceBreakSpeech} />
                    </div>
                    <span style={{ placeContent: 'center', placeSelf: 'center', fontStyle: 'italic', fontSize: '16px' }}>
                        {moleculeDetails.Vocab_Breakdown.split('-').map((syllable, index, array) => (
                            <span
                                key={index}
                                style={{
                                    color: highlightedSyllables.includes(syllable) ? 'rgba(57, 63, 73, 1)' : '',
                                }}
                            >
                                {syllable}
                                {index < array.length - 1 && "-"}
                            </span>
                        ))}
                    </span>
                    {showWordBreakVisualizer && (<div style={{ borderTop: '2px solid rgba(218, 223, 230, 1)' }}>
                        <AudioVisualizer /></div>
                    )}
                    {showWordBreakVisualizer && <SpeakText textToSpeak={moleculeDetails.Molecule_Name} speechRate={'0.2'} onSpeechEnd={onSpeechEnd} />}
                    {/* A-zith-ro-my-cin Di-hy-drate */}
                </div>
                {showDetails && <div className="info-section">
                    <InfoItem label="Definition" content={moleculeDetails.Definition} />
                    <InfoItem label="Mode of Action" content={moleculeDetails.Mode_of_Action} />
                    <InfoItem label="Common Usage" content={moleculeDetails.Common_Usage} />
                    <div className="info-associated-brands">
                        <span className="info-label">Associated Brand(s):</span>
                        <p className="info-description mb-0 mt-2">{moleculeDetails.Associated_Brands}</p>
                    </div>
                </div>}

                <div className='d-flex justify-content-center align-items-end gap-4' style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '3px solid rgba(243, 245, 247)' }}>
                    <img src={!showVisualizer ? hollowSpeech : filledBlueSpeech} alt='speech' className='s-16' onClick={handleHollowSpeechClick} />
                    <img src={share} alt='share' className='s-16' />
                    <img src={isFavorite ? favourite : hollowFavourite} alt='bookmark' className='s-16' onClick={addToBookmark} />
                </div>
            </div>


            <div className='mt-4'>
                <div className='mb-3'>Check your pronounciation</div>
                {/* <div className='d-flex justify-content-center mb-3'>{spokenText}</div> */}
                {isMicClicked && <div className='speechAnimatin'><Lottie options={defaultOptions} height={200} width={150} /></div>}
                <div className='detailsContainer'>
                    <div className='d-flex justify-content-around'>
                        <img src={restart} alt='close' className={`keybord ${isResetSpinning ? 'spin-animation' : ''}`} onClick={resetMic} />
                        <img src={blueMic} alt='close' className='mic' onClick={startRecognition} />
                        <img src={roundedCancel} alt='close' className='close' onClick={resetMic} />
                    </div>
                </div>

                {isMicClicked && (<SpeechRecognition
                    word={{ name: moleculeDetails.Molecule_Name, syllables: moleculeDetails.Vocab_Breakdown.split('-') }} // Passing only one word at a time
                    onWordComplete={handleWordComplete} // Callback to handle word completion
                />)}
            </div>

            {showPopup && (
                <div onClick={resetMic}>
                    <PopupMSG icon={accuracy >= 90 ?
                        celebration : accuracy >= 50 ? goodJob
                            : flower} message={accuracy >= 90 ? `Great job! You were ${accuracy}% accurate with your pronunciation. 
              Keep up the excellent work!`: accuracy >= 50 ? `Nice effort! You were ${accuracy}% accurate with your pronunciation. 
              Clear your throat and give it another go to boost your accuracy!`: `Keep practicing! Your accuracy was ${accuracy}%, 
              but don't worry, use the app regularly to refine your pronunciation and improve your score.`}
                        title={accuracy >= 90 ? 'Congratulations!' : accuracy >= 50 ? 'Good Attempt!' : 'Good Luck Next Time!'} />
                </div>)}
            {/* Fetch and display more detailed info here as needed */}
        </div>
    );
};

export default MoleculeDetails;

const InfoItem = ({ label, content }) => (
    <div className="info-item">
        <span className="info-label">{label}:</span>
        <p className="info-description mb-0">{content}</p>
    </div>
);
